import FormWithProvider from 'components/forms/form/Form';
import { ModalBody, ModalFooter } from 'react-bootstrap';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import { UsageType } from 'models/automation/Common';
import FormFieldset from 'components/forms/form/FormFieldset';
import useFetchTemplateSettings from 'components/domain/automation/useFetchTemplateSettings';
import { ManageLanguagesModalContainer } from './ManageLanguagesModal.styles';
import { getFormDefaultValues } from './ManageLanguagesModal.schema';
import ManageLanguagesLoader from './ManageLanguagesLoader';
import ManageLanguagesFields from './fields/ManageLanguagesFields';
import ManageLanguagesAutoTranslationField from './fields/ManageLanguagesAutoTranslationField';
import useManageLanguagesFormSubmit from './useManageLanguagesFormSubmit';

const ManageLanguagesModal = ({
  usageType,
  hideAutoTranslation = false,
}: {
  usageType: UsageType;
  hideAutoTranslation?: boolean;
}) => {
  const { handleSubmit } = useManageLanguagesFormSubmit({ usageType });
  const { data: templateSettings, isLoading } = useFetchTemplateSettings({
    usageType,
  });

  if (isLoading) {
    return <ManageLanguagesLoader hideAutoTranslation={hideAutoTranslation} />;
  }

  return (
    <FormWithProvider
      onSubmit={handleSubmit}
      defaultValues={getFormDefaultValues({ templateSettings })}
      horizontal
    >
      <FormFieldset>
        <ManageLanguagesModalContainer>
          <ModalBody>
            <ManageLanguagesFields />
            {!hideAutoTranslation && <ManageLanguagesAutoTranslationField />}
          </ModalBody>
          <ModalFooter>
            <ModalFormCancelButton />
            <ModalFormSubmitButton />
          </ModalFooter>
        </ManageLanguagesModalContainer>
      </FormFieldset>
    </FormWithProvider>
  );
};

ManageLanguagesModal.defaultProps = {
  hideAutoTranslation: false,
};

export default ManageLanguagesModal;
